// Mark all present on a held session's register (the mastermind build; the map's critic, build_now 4:
// live's register had it): everyone expected who isn't marked yet, marked present in 1 write. Anyone
// already marked keeps their mark, so an absence or an excused absence is never written over. Owner,
// admin, support, and a host for their own product's sessions, as any register line.
import { useState } from 'react'
import { Button } from '../ui/index.js'
import { REGISTER } from './words.js'
import '../../styles/admin-mastermind.css'
import { markAllPresent } from './data.js'

export function MarkAllPresent({ sessionId, rows, api, onSaved }) {
  const [busy, setBusy] = useState(false)
  const [line, setLine] = useState(null)
  const left = rows.filter(r => !r.status).length
  async function go() {
    if (busy || !left) return
    setBusy(true); setLine(null)
    try {
      const lines = await markAllPresent(api, { sessionId, rows })
      onSaved(lines || [])
      setLine({ text: REGISTER.markAllDone((lines || []).length) })
    } catch (e) {
      setLine({ bad: true, text: e.message })
    } finally {
      setBusy(false)
    }
  }
  return (
    <div className="amm-reg-tools adc-pad">
      <Button size="sm" busy={busy} disabled={!left} onClick={go}>{REGISTER.markAll}</Button>
      <span className="amm-muted">{left ? REGISTER.markAllHint : REGISTER.nobodyLeft}</span>
      {line && <span className={line.bad ? 'ad-error' : 'adc-flash'} role={line.bad ? 'alert' : 'status'}>{line.text}</span>}
    </div>
  )
}
